import { Controller } from "@hotwired/stimulus"

// The Held By choice on Settings > Certifications' add/edit slideover
// (TASK-283.7): shows the panel for the chosen holder, the matching hint under
// "Share with other teams", and disables that tick (with its hidden 0) when
// the signed-in member may not share the certificate - a member's own ticket
// is theirs alone to publish (doc-16 section 7).
export default class extends Controller {
  static targets = ["kind", "memberPanel", "namedPanel", "memberSelect", "share", "shareHidden", "hint"]
  static values = { ownMemberId: String }

  connect() {
    this.memberSelectTargets.forEach((el) => el.addEventListener("change", () => this.refresh()))
    this.refresh()
  }

  get kind() {
    const checked = this.kindTargets.find((el) => el.checked)
    return checked ? checked.value : "team"
  }

  refresh() {
    const kind = this.kind
    if (this.hasMemberPanelTarget) this.memberPanelTarget.classList.toggle("hidden", kind !== "member")
    if (this.hasNamedPanelTarget) this.namedPanelTarget.classList.toggle("hidden", kind !== "named_person")
    this.hintTargets.forEach((el) => el.classList.toggle("hidden", el.dataset.kind !== kind))

    const selected = this.hasMemberSelectTarget ? this.memberSelectTarget.value : ""
    const locked = kind === "member" && selected !== this.ownMemberIdValue
    if (this.hasShareTarget) {
      this.shareTarget.disabled = locked
      if (locked) this.shareTarget.checked = false
    }
    if (this.hasShareHiddenTarget) this.shareHiddenTarget.disabled = locked
  }
}
